// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_obR","cls2":"TranslationModal-cls2_iS9 TranslationModal-cls1_obR"};